function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-loc",
  transform: "translate(-2.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16 0 16 16 0 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.26,0 C5.084,0 2.5,2.6 2.5,5.795 C2.5,9.76 7.655,15.581 7.874,15.827 C8.08,16.057 8.44,16.057 8.646,15.827 C8.866,15.581 14.02,9.76 14.02,5.795 C14.02,2.599 11.436,0 8.26,0 Z M8.26,8.71 C6.65558667,8.7033862 5.35922962,7.39942457 5.362,5.795 C5.35867747,4.19018539 6.65519558,2.88561437 8.26,2.879 C9.86480442,2.88561437 11.1613225,4.19018539 11.158,5.795 C11.1607704,7.39942457 9.86441333,8.7033862 8.26,8.71 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})));

var SvgLoc = function SvgLoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loc.8157d714.svg";
export { ForwardRef as ReactComponent };